import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { Breadcrumb, Button, Card, Col, Form, Input, Modal, Row, Select, Switch, Table, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, CloseCircleFilled, SmallDashOutlined, SendOutlined } from '@ant-design/icons';
import DatePicker from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";
import { SetRoute } from '../scripts/action';
import { CheckPermission, PriceFormat , SearchFormat} from '../scripts/helpers';
import { Constants, Permissions } from '../scripts/settings';
import API from '../scripts/api';
import Resources from '../scripts/resources';
import PaginationInfo from '../components/PaginationInfo';
import ReminderPayForm from '../forms/ReminderPayForm';
import { Segmented } from "antd";

class ReminderPayPage extends Component {
    constructor() {
        super();

        this.state = {
            data: [],
            filter: [],
            pagination: {
                total: 0,
                current: 1,
                pageSize: Constants.pageSize,
                size: 'small'
            },
            selected: {},
            users: [],
            selectedUser: null,
            selectedRegistrar: null,
            registrars: [],
            filterDate: null,
            filterFromDate: null,
            filterToDate: null,
            regitrar: null,
            user: null,
            filterIsPay: false,
            cities: [],
            selectedCity: null,
        };

        this.formRef = React.createRef();

        this.handleFilter = debounce(this.handleFilter, 1000);
    }

    fetch = (params = {}) => {
        const { filterSearch, selectedRegistrar, filterDate, filterFromDate, filterToDate, selectedUser, filterIsPay, selectedCity } = this.state;
        // console.log(this.state.)

        let input = {}
        input.page = params.page;
        input.date = filterDate ? moment(`${filterDate.year}-${filterDate.month}-${filterDate.day}`, Constants.jDateFormat).format(Constants.dateFormat) : null;
        input.from_date = filterFromDate ? moment(`${filterFromDate.year}-${filterFromDate.month}-${filterFromDate.day}`, Constants.jDateFormat).format(Constants.dateFormat) : null;
        input.to_date = filterToDate ? moment(`${filterToDate.year}-${filterToDate.month}-${filterToDate.day}`, Constants.jDateFormat).format(Constants.dateFormat) : null;

        input.regsitrar = selectedRegistrar
        input.user = selectedUser
        input.is_pay = filterIsPay
        input.city = selectedCity
        console.log(input)
        this.setState({ loading: true });

        API.reminder_pay.list(input)
            .then((result) => {
                if (result.data) {
                    this.setState({
                        loading: false,
                        data: result.data.data,
                        pagination: {
                            ...this.state.pagination, ...{
                                current: result.data.current_page,
                                pageSize: result.data.per_page,
                                total: result.data.total
                            }
                        }
                    });
                     this.setState({ loading: false });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    showModal = (offer = {}) => {
        this.setState({ visibleModal: true, selected: offer });

        setTimeout(() => {
            this.formRef.current.handleDidMount(offer);
        }, 0);
    }

    hideModal = () => {
        this.setState({ visibleModal: false });

        setTimeout(() => {
            this.formRef.current.handleWillUnmount();
        }, 0);
    }


    handleFilterSearch = (value, type) => {
        console.log(value, type)
        const state = {};
        state[type] = value;

        this.setState(state);

        setTimeout(() => {
            this.fetch({ page: 1 });
        }, 0);
    }

    handleStatus = (record) => {
        Modal.confirm({
            title: record.status ? Resources.confirmOfferDeactivate : Resources.confirmOfferActivate,
            okText: Resources.yes,
            okType: record.status ? 'danger' : 'primary',
            cancelText: Resources.no,
            onOk: () => {
                this.setState({ loading: true });

                API.reminder_pay.payed(record.id)
                    .then((result) => {
                        message.success(result.message);
                        this.fetch({ page: this.state.pagination.current });
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    }

    handleDelete = (record) => {
        Modal.confirm({
            title: Resources.confirmDeleteOffer,
            okText: Resources.yes,
            okType: 'danger',
            cancelText: Resources.no,
            onOk: () => {
                this.setState({ loading: true });

                API.reminder_pay.delete(record.id)
                    .then((result) => {
                        message.success(result.message);

                        this.fetch({ page: this.state.pagination.current });
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    }

    sendSms = (record) => {
        Modal.confirm({
            title: Resources.confirmSendSms,
            okText: Resources.yes,
            okType: 'danger',
            cancelText: Resources.no,
            onOk: () => {
                this.setState({ loading: true });

                API.reminder_pay.sendsms({}, record.id)
                    .then((result) => {
                        // message.success(result.message);

                        this.fetch({ page: this.state.pagination.current });
                        this.setState({ loading: false });

                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    }

    handleSubmit = (values) => {
        const action = this.state.selected.id ? API.reminder_pay.update : API.reminder_pay.add;

        this.setState({ submitting: true });

        action(values, this.state.selected.id)
            .then((result) => {
                message.success(result.message);
                this.setState({ submitting: false });
                this.hideModal();
                this.fetch({ page: this.state.pagination.current });
            })
            .catch(() => {
                this.setState({ submitting: false });
            });
    }

    handleTableChange = (pagination) => {
        this.fetch({ page: pagination.current });
    }

    componentDidMount() {
        const { onSetRoute, routeName, parentName } = this.props;

        onSetRoute({ openKey: parentName, selectedKey: routeName });

        this.fetch({ page: 1 });
        this.cities()
    }

    handleFilter = (input, option) => {
        const code = option.props.code || "";
        const value = input || "";
        const split = value.split(' ');

        let valid = code.indexOf(value) >= 0;

        split.forEach(val => {
            valid = valid || code.indexOf(val) >= 0;
        });

        return valid;
    };


    handleSearch = (value, type) => {
        if (!value) return;

        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            API.user.search({q: value}).then((result) => {
            const list = result.data?.length
                ? result.data.map(o => ({
                    id: o.id,
                    name: o.name,
                    family: o.family,
                    phone: o.phone,
                    value,
                    count: 1,
                }))
                : [];
            this.setState({ [type]: list });
            });
        }, 300);
    };

    handleSelect = (value, clear, type) => {
        const list = this.state[type] || [];
        const selectedList = this.state[`selected${type}`] || [];

        const existing = selectedList.find(o => o.id === value);
        if (existing) {
            this.handleCount(existing.count + 1, existing, type);
        } else {
            const item = list.find(o => o.id === value);
            this.setState({ [`selected${type}`]: [...selectedList, item] });
        }

        if (clear) this.setState({ [type]: [] });
        this.fetch({ page: 1 });
    };

    handleCount = (value, record, type) => {
        const list = [...this.state[type]];
        const index = list.findIndex(o => o.id === record.id);
        if (index >= 0) {
            list[index] = { ...list[index], count: value };
            this.setState({ [type]: list });
        }
    };


    handleDateFilter = (value, type) => {
        this.setState(
            { [type]: value },
            () => {
                this.fetch({ page: 1 });
            }
        );
    };

    handlePayToggle = (checked) => {
        const value = checked ? 1 : 0;

        this.setState(
            { filterIsPay: value },
            () => this.fetch({ page: 1 })
        );
    };


    cities = () =>{
        API.city.list(1).then(res => {
            this.setState({
            cities: res.data || []
            });
        });
        }
    // end maange search users


      // -------------------------
  // City Change
  // -------------------------
  handleCityChange = (cityId) => {
    this.setState(
      {
        selectedCity: cityId,
      },
      () => {
        this.fetch({page: 1});
      }
    );
  };

    render() {
        const { data, loading, pagination, submitting, visibleModal,
            users, registrars, filterDate, filterFromDate, filterToDate
         } = this.state;
        const { permissions } = this.props;

        const columns = [{
            title: `${Resources.user}`,
            dataIndex: 'user',
            className: 'col-center',
            width: '120px',
            render: val => val.name + " "+ val.family
        }, 
        {
            title: Resources.cashPrice,
            dataIndex: 'cash_price',
            className: 'col-center',
            render: val => PriceFormat(val)
        }
        ,
        {
            title: Resources.checkPrice,
            dataIndex: 'check_price',
            className: 'col-center',
            render: val => PriceFormat(val)
        },
        
         {
            title: Resources.newFactor,
            dataIndex: 'price',
            className: 'col-center',
            render: val => PriceFormat(val)
        },
        //  {
        //     title: Resources.payed,
        //     dataIndex: 'is_pay',
        //     className: 'col-center',
        //     width: '70px',
        //     render: (val, record) => <Switch size="small" checked={!!parseInt(val)} onClick={() => this.handleStatus(record)}  />
        // },
        {
            title: Resources.smsCount,
            dataIndex: 'sms_count',
            className: 'col-center',
            render: val => PriceFormat(val)
        }
    ];

        // if (permissions.action) {
            columns.push({
                title: Resources.action,
                dataIndex: 'id',
                className: 'col-center',
                width: '120px',
                render: (val, record) => (
                    <Fragment>
                        <Tooltip title={Resources.edit}>
                            <Button type="link" icon={<EditOutlined />} onClick={() => this.showModal(record)} />
                        </Tooltip>
                        <Tooltip title={Resources.delete}>
                            <Button style={{color: "red"}} type="link" icon={<DeleteOutlined />} onClick={() => this.handleDelete(record)} />
                        </Tooltip>
                         <Tooltip title={Resources.sendSms}>
                             <Button
                                type="primary"
                                onClick={() => this.sendSms(record)}
                                icon={<SendOutlined />}
                            >
                                ارسال پیامک
                            </Button>
                            {/* <Button type="link" icon={<SmallDashOutlined />} onClick={() => this.sendSms(record)} /> */}
                        </Tooltip>
                    </Fragment>
                )
            });
        // }

        // const DatePickerInput = ({ ref }, date, placeholder) => (
        //     <Input value={date ? `${date.year}-${date.month}-${date.day}` : date} placeholder={placeholder} ref={ref} readOnly />
        // );
        const DatePickerInput = (props, date, placeholder, clear) => (
            <Input
                {...props}
                value={date ? `${date.year}-${date.month}-${date.day}` : ""}
                placeholder={placeholder}
                readOnly
                suffix={
                    date ? (
                        <CloseCircleFilled
                            onClick={(e) => {
                                e.stopPropagation();
                                clear();
                            }}
                        />
                    ) : null
                }
            />
        );

        return (
            <Fragment>
                <Breadcrumb>
                    <Breadcrumb.Item>{Resources.reminderPay}</Breadcrumb.Item>
                </Breadcrumb>
                <div className="ant-content">
                    <Card
                        bordered={false}
                        style={{ backgroundColor: '#f0f2f5', padding: '16px', borderRadius: '8px' }} // پس‌زمینه ملایم و گوشه‌های گرد
                        bodyStyle={{ padding: '0px' }} // حذف padding داخلی کارت
                    >
                        <Row gutter={24}>
                             <Col xs={24} md={4}>
                                <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
                            </Col>
                            
                            <Col >
                                <Form.Item  label={Resources.date}>
                                  <DatePicker
                                        locale="fa"
                                        value={filterDate}
                                        onChange={(value) => this.handleDateFilter(value, 'filterDate')}
                                        renderInput={(props) =>
                                            DatePickerInput(
                                                props,
                                                filterDate,
                                                Resources.date,
                                                () => this.handleDateFilter(null, 'filterDate')
                                            )
                                        }
                                        shouldHighlightWeekends
                                    />

                                    {/* {filterDate && <CloseCircleFilled className="ant-input-clear-icon ant-input-clear-icon-external" onClick={() => this.handleFilter(null, 'date')} />} */}
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item  label={Resources.fromDate}>
                                    <DatePicker
                                        locale="fa"
                                        value={filterFromDate}
                                        onChange={value => this.handleDateFilter(value, 'filterFromDate')}
                                        renderInput={(props) =>
                                            DatePickerInput(
                                                props,
                                                filterFromDate,
                                                Resources.fromDate,
                                                () => this.handleDateFilter(null, 'filterFromDate')
                                            )
                                        }                                        shouldHighlightWeekends
                                    />

                                    {filterFromDate && <CloseCircleFilled className="ant-input-clear-icon ant-input-clear-icon-external" onClick={() => this.handleFilter(null, 'fromDate')} />}
                                </Form.Item>
                                </Col>
                            <Col>

                                <Form.Item  label={Resources.toDate}>
                                    <DatePicker
                                        locale="fa"
                                        value={filterToDate}
                                        onChange={value => this.handleDateFilter(value, 'filterToDate')}
                                        renderInput={(props) =>
                                            DatePickerInput(
                                                props,
                                                filterToDate,
                                                Resources.toDate,
                                                () => this.handleDateFilter(null, 'filterToDate')
                                            )
                                        }                                        shouldHighlightWeekends
                                    />

                                    {/* {filterToDate && <CloseCircleFilled className="ant-input-clear-icon ant-input-clear-icon-external" onClick={() => this.handleFilter(null, 'toDate')} />} */}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={10} md={6}>
                                <Form.Item name="registrar_id" label={Resources.user}>
                                    <Select
                                        allowClear
                                        value={this.state.selectedRegistrar}
                                        showSearch
                                        filterOption={false}   // مهم ✅
                                        onSearch={(val) => this.handleSearch(val, 'registrars')}
                                        onChange={(val) => {
                                            this.setState(
                                                { selectedRegistrar: val },
                                                () => this.fetch({ page: 1 })
                                            );
                                            // this.setState({ selectedRegistrar: val });
                                            // this.fetch({ page: 1, registrar_id: val });
                                        }}
                                        placeholder={Resources.search}
                                    >
                                        {registrars.map(o => (
                                            <Select.Option
                                                key={o.id}
                                                value={o.id}
                                            >
                                                {o.name + " " + o.family}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={10} md={6}>
                                <Form.Item name="user_id" label={Resources.customer} >
                                    <Select
                                        allowClear
                                        value={this.state.selectedUser}
                                        showSearch
                                        filterOption={false}   // مهم ✅
                                        onSearch={(val) => this.handleSearch(val, 'users')}
                                        onChange={(val) => {
                                            this.setState(
                                                { selectedUser: val },
                                                () => this.fetch({ page: 1 })
                                            );
                                            // this.setState({ selectedUser: val });
                                            // this.fetch({ page: 1, user_id: val });
                                        }}
                                        placeholder={Resources.search}
                                    >
                                        {users.map(o => (
                                            <Select.Option
                                                key={o.id}
                                                value={o.id}
                                            >
                                                {o.name + " " + o.family}
                                            </Select.Option>
                                        ))}
                                    </Select>

                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={10} md={6}>
                                <Form.Item label="شهر">
                                    <Select
                                        showSearch
                                        allowClear
                                        value={this.state.selectedCity}
                                        placeholder="انتخاب شهر"
                                        onChange={this.handleCityChange}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {this.state.cities.map(c => (
                                            <Select.Option key={c.id} value={c.id} >
                                                {c.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>




                        
                          <Col xs={24} sm={10} md={6}>
                                <Form.Item label="پرداخت">
                                    <Switch
                                        checkedChildren="پرداخت شده"
                                        unCheckedChildren="پرداخت نشده"
                                        onChange={this.handlePayToggle}
                                        checked={this.state.filterIsPay === 1}
                                    />
                                </Form.Item>
                        </Col>



                        </Row>
                    </Card>
                  
                </div>
                <div className="ant-content">
                    <Table
                        columns={columns}
                        dataSource={data}
                        loading={loading}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                        size="small"
                        rowKey="id"
                        scroll={{ x: 600 }}
                    />
                    {!!pagination.total && <PaginationInfo current={pagination.current} pageSize={pagination.pageSize} total={pagination.total} />}
                </div>
                <ReminderPayForm ref={this.formRef} onCancel={this.hideModal} onSubmit={this.handleSubmit} submitting={submitting} visible={visibleModal} />
            </Fragment>
        );
    }
};

export default connect(
    (state) => {
        return {
            permissions: {
                action: CheckPermission(state.app.user, Permissions.special_option),
                add: CheckPermission(state.app.user, Permissions.special_store)
            }
        };
    },
    (dispatch) => {
        return {
            onSetRoute: (data) => dispatch(SetRoute(data))
        };
    }
)(ReminderPayPage);